import {  MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Icon } from "@iconify/react";
import { InputAdornment, TextField, Tooltip } from "@material-ui/core";
import React from "react";

export default function BetterTextField(props) {
	const { search, tooltipText, ...rest } = props;

	return (
		<div className={`better-text-field ${props.value && !props.error ? 'preenchido' : ''}`}>
			<TextField
				{...rest}
				variant="outlined"
				InputProps={{
					...rest.InputProps,
					startAdornment: search ? (
						<InputAdornment position="start">
							<MagnifyingGlassIcon width={24} color="#555555" />
						</InputAdornment>
					) : rest.InputProps?.startAdornment,

					endAdornment: tooltipText ? (
						<InputAdornment position="end">
							<Tooltip title={tooltipText} placement="right" arrow>
								<div style={{ display: 'flex', cursor: 'pointer' }}>
									<Icon icon="solar:info-circle-bold" width="16" />
								</div>
							</Tooltip>
						</InputAdornment>
					) : rest.InputProps?.endAdornment,
				}}
			/>
		</div>
	);
}